export default {
    COMPLECTATIONS: [
        {
            model: "OUTLANDER",
            complectation: "Inform",
            engine: "2.0 MIVEC 2WD"
        },
        {
            model: "OUTLANDER",
            complectation: "Invite",
            engine: "2.0 MIVEC 2WD"
        },
        {
            model: "OUTLANDER",
            complectation: "Invite",
            engine: "2.0 MIVEC 4WD"
        },
        {
            model: "OUTLANDER",
            complectation: "Intense+",
            engine: "2.0 MIVEC 2WD"
        },
        {
            model: "OUTLANDER",
            complectation: "Intense+",
            engine: "2.0 MIVEC 4WD"
        },
        {
            model: "OUTLANDER",
            complectation: "Instyle",
            engine: "2.0 MIVEC 4WD"
        },
        {
            model: "OUTLANDER",
            complectation: "Instyle",
            engine: "2.4 MIVEC 4WD"
        },
        {
            model: "OUTLANDER",
            complectation: "Ultimate",
            engine: "2.4 MIVEC 4WD"
        },
        /* {
            model: "L200",
            complectation: "DC Invite",
            engine: "2.4 DID 4WD"
        }, */
        // {
        //     model: "ECLIPSE CROSS",
        //     complectation: "Instyle",
        //     engine: "1.5T MIVEC 4WD"
        // },
        // {
        //     model: "ECLIPSE CROSS",
        //     complectation: "Ultimate",
        //     engine: "1.5T MIVEC 4WD"
        // },
        {
            model: "PAJERO SPORT",
            complectation: "Invite",
            engine: "2.4 DI-D 4WD"
        },
        {
            model: "PAJERO SPORT",
            complectation: "Intense",
            engine: "2.4 DI-D 4WD"
        },
        {
            model: "PAJERO SPORT",
            complectation: "Instyle",
            engine: "2.4 DI-D 4WD"
        },
        {
            model: "PAJERO SPORT",
            complectation: "Instyle",
            engine: "3.0 MIVEC 4WD"
        },
        {
            model: "PAJERO SPORT",
            complectation: "Ultimate",
            engine: "2.4 DI-D 4WD"
        },
        {
            model: "PAJERO SPORT",
            complectation: "Ultimate",
            engine: "3.0 MIVEC 4WD"
        },
        // {
        //     model: "Обновленный ASX",
        //     complectation: "Inform",
        //     engine: "1.6 MIVEC 2WD"
        // },
        // {
        //     model: "Обновленный ASX",
        //     complectation: "Invite",
        //     engine: "1.6 MIVEC 2WD"
        // },
        // {
        //     model: "Обновленный ASX",
        //     complectation: "Intense",
        //     engine: "1.6 MIVEC 2WD"
        // },
        // {
        //     model: "Обновленный ASX",
        //     complectation: "Intense",
        //     engine: "2.0 MIVEC 2WD"
        // },
        // {
        //     model: "Обновленный ASX",
        //     complectation: "Instyle",
        //     engine: "2.0 MIVEC 2WD"
        // },
        /* {
            model: "PAJERO",
            complectation: "Instyle",
            engine: "3.0 4WD"
        }, */
    ]
}